import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import styled from "styled-components";
import ContainerHistoryUpdate from "../../history/ContainerHistoryUpdate";
import TitleSection from "./TitleSection";
import {useMatch} from "react-router";
import {deleteOneProject, loadProject} from "../../project/one-project/projectAction";
import {GUIDED_UPDATE_PROJECT_WITH_ID_ROUTE} from "../../../routes/routesName";
import {CLEAR_PROJECT} from "../../project/actionsType";
import {loadProjects} from "../../project/projects/projectsAction";
import UpdateProject from "../../project/one-project/update/UpdateProject";
import {useNavigate} from "react-router-dom";


const UpdateProjectSection = ({toggleHandler, setCount}) => {
    const navigate = useNavigate();
    const {params: {id: projectId}} = useMatch(GUIDED_UPDATE_PROJECT_WITH_ID_ROUTE)
    const {id: currentUserId, status} = useSelector(state => state.currentUser)
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
    const [isOpenUpdateProject, setIsOpenUpdateProject] = useState(true)


    const dispatch = useDispatch()
    const {
        id,
    } = useSelector(state => state.project)

    useEffect(() => {
        dispatch(loadProject(projectId))
        if(!isOpenUpdateProject) {
            setCounter(1)
        }
    }, [dispatch, projectId, isOpenUpdateProject])

    const updateProject = async () => {
        await dispatch(loadProject(id))
        setIsOpenUpdateProject(true)
    }

    const handleDelete = () => {
        setIsOpenDeleteModal(!isOpenDeleteModal)
    }
    const displayModal = () => {
        if (isOpenUpdateProject) {
            return <UpdateProject setIsOpenUpdateProject={setIsOpenUpdateProject}/>
        }
    }
    const deleteRequest = async (project_id) => {
        if (status === 200) {
            await dispatch(deleteOneProject(project_id))
            setIsOpenDeleteModal(false);
            dispatch({type: CLEAR_PROJECT})
            if (status === 200) {
                navigate(`/`);
            }
            await dispatch(loadProjects(currentUserId))
        }
    }

    const setCounter = (nb) => {
        setCount(nb);
    }
    const data = [
        {count: 1, title: 'Analyse projet (SWOT)'},
        {count: 2, title: "L'équipe"},
        {count: 3, title: "L'idéation"},
        {count: 4, title: 'Objectifs et résultat clés (OKRs)'},
        {count: 5, title: 'Le plan d\'action'},
        {count: 6, title: 'Bilan et évaluation'},
    ]

    return (
        <>
            {displayModal()}
        </>
    )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
  align-items: center;
  justify-content: center;
`

const MainWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  gap: 1rem;
  @media (min-width: 900px) {
    flex-direction: row;
    height: 100%;
    margin-top: 3rem;
  }
`

const HistoryUpdate = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-grow: 0.7;
  height: 100%;
  @media (min-width: 900px) {
    max-width: 50%;
  }
`

const Text = styled.p`
  color: var(--color-white);
  font-size: 15px;
  font-weight: bold;
`

const Ul = styled.ul`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  @media (min-width: 900px) {
    width: 40%;  
    justify-content: space-between;
  }
`


const Button = styled.button`
  border: 2px solid transparent;
  background: var(--color-purple-06);
  width: 100%;
  height: 100%;
  text-align: left;
  border-radius: 5px;
  padding: 0.75rem;

  &:hover {
    background: var(--color-white);
    cursor: pointer;
    border-color: var(--color-purple-06);

    p {
      color: #4909AA;
    }
  }
`
const ButtonContainer = styled.div`
  display: flex;

`
const SettingsButton = styled.button`
  padding: 0.5rem;
  border: none;
  background-color: var(--color-blue);
  color: white;
  border-radius: 10px;
  cursor: pointer;
  margin-left: 0.5rem;
`
const DeleteProjectButton = styled.button`
  padding: 0.5rem;
  border: none;
  background-color: var(--color-red);
  color: white;
  border-radius: 10px;
  cursor: pointer;
  margin-left: 0.5rem;  
`


export default UpdateProjectSection;
